import { render, staticRenderFns } from "./DocumentNumberForm.vue?vue&type=template&id=5e6fa2cd&"
import script from "./DocumentNumberForm.vue?vue&type=script&lang=ts&"
export * from "./DocumentNumberForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports